<template>
  <a
    href="javascript:void(0)"
    class="link related-cell"
    @click.prevent="changeContent(thumb)"
  >
    <div class="thumb-box">
      <ul class="badge-list">
        <li class="left-top-area">
          <ul v-top-tag-list="tagList(thumb)"></ul>
        </li>
      </ul>
      <div v-if="image" class="picture-area">
        <WebpImage
          :image-info="{
            imageUrl: image,
            width: 407,
            height: 229,
            alt: alt,
            onImageLoad,
          }"
        />
      </div>
      <div v-else class="no-thumb" :aria-hidden="!isImageLoaded">
        <span class="alt-text">{{ alt }}</span>
      </div>
    </div>
    <div class="sub-title">
      <div v-title-list="{ titleList: titleList }" class="sub-right"></div>
    </div>
  </a>
</template>

<script>
  import _ from 'lodash'
  import {
    commonTagList,
    titleList,
    topTagList,
  } from '@/common/resources/directives'
  import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'
  import WebpImage from '@/components/image/WebpImage'

  export default {
    name: 'RelatedItem',
    components: { WebpImage },
    directives: {
      titleList,
      topTagList,
      commonTagList,
    },
    props: {
      thumb: {
        type: Object,
      },
    },
    data() {
      return {
        isImageLoaded: false,
      }
    },
    computed: {
      image() {
        return _.get(this.thumb, 'thumbnail', '')
      },
      alt() {
        return _.get(this.thumb, 'alt', '')
      },
      titleList() {
        return _.get(this.thumb, 'title_list', [])
      },
    },
    methods: {
      changeContent(thumb) {
        const { contentid = '', movieid = '' } = thumb
        const { path = '' } = this.$route
        const section = path.split('/').pop()
        const query =
          section === 'vod' ? { contentid: contentid } : { movieid: movieid }

        this.$router.push({
          name: PATH_NAME_PLAYER_STREAM,
          params: { section: section },
          query: query,
        })
      },
      tagList(thumb) {
        return _.get(thumb, 'top_taglist', []).concat(
          _.get(thumb, 'bottom_taglist', []),
        )
      },
      onImageLoad() {
        this.isImageLoaded = true
      },
    },
  }
</script>
<style lang="scss">
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .related-cell {
    .cell-title .title1 {
      color: #fff;
    }
    .cell-title .title2 {
      font-size: 16px;
    }
    .cell-title + .cell-title {
      margin-top: 4px;
    }
  }
</style>
<style lang="scss" scoped>
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .sub-title {
    padding-right: 0;
  }
  .thumb-box .no-thumb .alt-text {
    @include Ellipsis($multi: true, $line: 2);
    overflow: hidden;
    word-wrap: break-word;
    font-size: 20px;
    color: #fff;
    text-align: center;
    line-height: 29px;
    white-space: inherit;
  }
  .thumb-box {
    position: relative;
    overflow: hidden;
    height: 229px;
    background-color: $neutral-30;
    border-radius: 12px;
  }
  .thumb-box .no-thumb {
    @include Position(absolute, $left: 0, $right: 0, $top: 0, $bottom: 0);
    display: flex;
    flex-direction: column;
    background-color: #252525;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    z-index: 10;
  }
  .link {
    display: block;
  }
</style>
